import React, { useState, useRef } from 'react';
import { Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, Paper, IconButton, Tooltip } from '@material-ui/core';
import { GoogleMap, LoadScript, DrawingManager, Polygon } from '@react-google-maps/api';
import { Marker } from '@react-google-maps/api';
import { connect } from 'react-redux'
import axios from 'axios'
import CustomMarker from './CustomMarker'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import { useLocation } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PrintIcon from '@material-ui/icons/Print'
import CloseIcon from '@material-ui/icons/Close'

const mapLibraries = ["drawing", "geometry"];

const containerStyle = {
  width: '100%',
  height: '90vh'
};

const center = {
  lat: 33.72972977616888,
  lng: -111.9839555679331
};

const position = {
  lat: 33.7,
  lng: -111.97
}

const onLoad = marker => {
// console.log('marker: ', marker)
}
// const image = "https://dflportal.com/favicon.png"
const dfl = "https://dflportal.com/favicon.png"
const benhart = "https://www.benhartlandscaping.com/wp-content/themes/benhart/img/icons/favicon-16x16.png"

const colors = ['#ACCACD', '#1c801f', '#84d1e0', '#84e0b0', '#bbe084', '#689623', '#239670']
// 20, 27, 19, 21, 18
const distinctHexColorsOLD = [
  "#D32F2F",
  "#1976D2",
  "#388E3C",
  "#FBC02D",
  "#8E24AA",
  "#0288D1",
  "#C2185B",
  "#7B1FA2",
  "#F57C00",
  "#C0CA33",
  "#F9A825",
  "#8C9EFF",
  "#FF8A80",
  "#F5F5F5",
  "#FFAB40",
  "#84FFFF",
  "#80D8FF",
  "#A7FFEB",
  "#0058aa",
  "#13ad53",
  "#1DE9B6",
  "#FF0000",
  "#69F0AE",
  "#00BFA5",
  "#00E676",
  "#76FF03",
  "#C6FF00",
  "#FFD600",
  "#FF5733",
  "#33FF57",
  "#5733FF", "#FF33E3", "#E333FF", "#33FFE3", "#FFFF33",
  "#33FFFF", "#33FF33", "#FF3333", "#3333FF", "#33FFFF",
  "#AA00FF", "#00AAFF", "#FF00AA", "#FFAA00", "#00FFAA",
  "#5500FF", "#0055FF", "#FF0055", "#FF5500", "#0055FF",
  "#11FF00", "#FF0011", "#0011FF", "#FF1100", "#0011FF",
  "#FF00FF", "#00FFFF", "#FFFF00", "#00FF00", "#FF0000",
  "#0000FF", "#0000AA", "#000055", "#555555", "#AAAAAA",
  "#111111", "#222222", "#333333", "#444444", "#666666",
  "#777777", "#888888", "#999999", "#BBBBBB", "#CCCCCC",
  "#DDDDDD", "#EEEEEE", "#F0F0F0", "#F1F1F1", "#F2F2F2",
  "#F3F3F3", "#F4F4F4", "#F5F5F5", "#F6F6F6", "#F7F7F7",
  "#F8F8F8", "#F9F9F9", "#FAFAFA", "#FBFBFB", "#FCFCFC",
  "#FEFEFE", "#C0C0C0", "#B0B0B0", "#A0A0A0", "#909090",
];

const calculateVisitFrequency = (frequency) => {
  let numberOfVisits = 0
  switch (frequency) {
      case 'weekly':
          numberOfVisits = 52
          break;
      case 'biweekly':
          numberOfVisits = 26
          break;
      case 'monthly':
          numberOfVisits = 12
          break;
  }
  return numberOfVisits / 12
}

const calculateJakesThing = (markers) => {
  let totalHoursOfWorkPerMonth = 0
  let totalDollarsChargedPerMonth = 0
  markers.map(item => {
    // console.log('Calculate our hours and rate')
    let numberOfVisitsPerMonth = calculateVisitFrequency(item.frequency)
    // console.log('Visits:', numberOfVisitsPerMonth)
    let monthlyRate = item.price
    let minutesOfWorkPerVisit = item.estMinutes
    let hour = minutesOfWorkPerVisit / 60
    // console.log('Hours of work:', hour)
    let totalHoursPerMonth = numberOfVisitsPerMonth * hour
    let dolhr = monthlyRate / totalHoursPerMonth
    // console.log('$ dollars per hour', dolhr)
    dolhr = parseFloat(dolhr).toFixed(2)
    // console.log('This guy is:', dolhr)
    totalHoursOfWorkPerMonth += Number(totalHoursPerMonth)
    totalDollarsChargedPerMonth += Number(monthlyRate)
  })
  // Average charge per HOUR
  // console.log("Total WORK", totalHoursOfWorkPerMonth)
  // console.log('TOtal Revenue:', totalDollarsChargedPerMonth)
  let ourAverage = parseFloat(totalDollarsChargedPerMonth / totalHoursOfWorkPerMonth).toFixed(2)
  // console.log('Average:', ourAverage)
  return ourAverage
}

const calculateOurDollarsPerHours = (item) => {
  if (item && item.estMinutes) {
      let frequency = item.frequency
      let numberOfVisitsPerMonth = calculateVisitFrequency(frequency)
      let estMinutes = item.estMinutes
      // let totalMinutesOfWorkAnnually = Number(estMinutes) * Number(numberOfVisitsPerYear)
      let hour = estMinutes / 60
      console.log('Hours of work:', hour)
      let totalHoursPerMonth = numberOfVisitsPerMonth * hour
      let amt = item.price
      let dolhr = amt / totalHoursPerMonth
      console.log('$ dollars per hour', dolhr)
      dolhr = parseFloat(dolhr).toFixed(2)
      return dolhr
  }
  return null
}

function generateUniqueHexColors(count) {
  const colors = new Set();
  const result = [];

  while (colors.size < count) {
    const color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    colors.add(color);
  }

  colors.forEach((color) => {
    result.push(color);
  });

  return result;
}

// Example usage to generate 70 unique colors:
const distinctHexColors = distinctHexColorsOLD // generateUniqueHexColors(100);

// const distinctHexColors = ["#c331a2", "#998531", "#839fc7", "#4b61b6", "#131409", "#bb2989", "#2ee1f2", "#f3f039", "#a5ca90", "#55106b", "#ce082f", "#0f447f", "#df8145", "#8eb7ee", "#8c9fa5", "#6858e8", "#9689e0", "#69f468", "#404061", "#972e3e", "#a02f62", "#2ba010", "#ed93b1", "#149091", "#793be2", "#fe3d0e", "#1a239f", "#7a0aee", "#d96f62", "#18546d", "#510ad6", "#6dca75", "#101224", "#a42c25", "#8c1739", "#a558ba", "#4e2aea", "#4ce829", "#96e0c8", "#4f3842", "#fd2953", "#3d020c", "#eb6419", "#50bbce", "#292208", "#26e6b2", "#ea857e", "#9b44d0", "#c52f5c", "#056e88", "#21dd3b", "#bc6eea", "#b24545", "#857d44", "#1331fa", "#731d99", "#b60b0c", "#b43d94", "#787348", "#f015a9", "#6ed073", "#dc496d", "#b87447", "#880e01", "#dbf99d", "#5308e2", "#0a54dc", "#f38648", "#77cbbe", "#c48ad1"]
const polygonOptions = {
  fillOpacity: 0.3,
  fillColor: '#ff0000',
  strokeColor: '#ff0000',
  strokeWeight: 2,
  draggable: true,
  editable: true
}

const Sidebar = (props) => {
  // console.log('SIDEBAR;', props)
  const activeMarker = props.activeMarker
  // const crews = props.crews
  let markers = props.markers
  // console.log('SIde bar: ', markers)
  // const legendData = []
  // markers.map(item => {
  //   let isInLegendIndex = legendData.findIndex(crew => (crew.crewId === item.crewId))
  //   if (isInLegendIndex < 0) {
  //     let color = setMarkerColorBasedOnCrew(item.crewId, crews)
  //     console.log('Color:', color)
  //     legendData.push(
  //       {
  //       color: color,
  //       crewName: item.crewName,
  //       crewId: item.crewId
  //     })
  //   }
  // })
  // let avgHourlyRate = calculateJakesThing(markers) || 'Not Available'
  // console.log('Avg hourly rate:', avgHourlyRate)
  // console.log('Legend Data:', legendData)
  // console.log('Active Marker', activeMarker)
  const handlePrintList = async () => {
    // console.log('Print that shit!')
    let resp = await axios.get(`${props.url}/api/hmi/printJobsites`)
    // console.log('Print Response:', resp)
    let newBlob = new Blob([resp.data], {type: "text/csv"})
    // console.log(newBlob)
    const data = window.URL.createObjectURL(newBlob);
    // console.log(data)
    var link = document.createElement('a');
    link.href = data;
    let fileName = 'HMI_Jobsites'.replace(/[^a-z0-9]/gi, '_').toLowerCase()
    link.download=`${fileName}.csv`;
    link.click();
  }


  return (
    <div style={{ overflowY: 'scroll', padding: 10, width: '100%', height: '90vh', zIndex: 9999, backgroundColor: '#bbb'}} >
      <Grid container spacing={2}>
      <Grid item lg={6} xs={12} sm={12} md={6}>
        <div style={{ marginTop: '16px'}}>
          Total Jobsites: {markers.length}

        </div>
       
      </Grid>
      <Grid item lg={6} xs={12} sm={12} md={6}>
        <Tooltip
          title="Print List"
          >
                      <IconButton
           
           onClick={handlePrintList}
         >
           <PrintIcon size={24} />
         </IconButton>

          </Tooltip>

      </Grid>
    
      {
        (activeMarker && activeMarker._id) ? (
          <React.Fragment>
            
              <ActiveMarkerDetails activeMarker={activeMarker} handleUnassign={props.handleUnassign} />
     


            <Grid item lg={12} xs={12} sm={12} md={12}>
              <FilterArea crews={props.crews} assignThisCrew={props.handleAssignCrew} />
            </Grid>
     
          </React.Fragment>
        ) : null
      }
        <Grid item lg={12} xs={12} sm={12} md={12}>
          <Legend data={props.legendData} />
        </Grid>
      </Grid>
    </div>
  )
}

const ActiveMarkerDetails = ({ activeMarker, handleUnassign }) => {
  const clientName = activeMarker?.client?.displayName
  const address = `${activeMarker?.address} ${activeMarker?.city}, ${activeMarker?.zip}`
  // console.log('active marker 272', activeMarker)

  return (
    <Grid container style={{ margin: 10, backgroundColor: '#fff', padding: 15, borderRadius: 8 }}>
      Active Marker
      <Grid item lg={12} xs={12} sm={12} md={12}>
        Client:  { clientName }
      </Grid>
      <Grid item lg={12} xs={12} sm={12} md={12}>
        Address:  { address }
      </Grid>

      <Grid item lg={12} xs={12} sm={12} md={12}      >
       

        {
           (activeMarker.assignedCrew && activeMarker.assignedCrew._id) ? (
            <div   style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              paddingHorizontal: '4px'
            }}>
               <div>Assigned Irrigation Crew: </div>
              <div style={{ marginLeft: '5px' }}>{`  ${activeMarker.assignedCrew.name}   `}</div>
               <div style={{ width: '20px', height: '20px', backgroundColor: activeMarker.color, display: 'inlineBlock', marginLeft: '5px' }}></div>
               <div onClick={e => handleUnassign(activeMarker) } style={{ marginBottom: '5px', cursor: 'pointer' }}><CloseIcon size={12} /></div>
            </div>
             
           ) : null
        }
      </Grid>
    </Grid>
  )
}

const Legend = ({ data }) => {
  // console.log('Build our Legend:', data)

  return (
    <Grid container style={{ backgroundColor: '#aaa', padding: 15, borderRadius: 8 }}>
      Legend
      <Grid item lg={12} xs={12} sm={12} md={12}>
        {
          data.map((item, index) => {

            return (
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', alignContent: 'center', padding: 8, border: '2px solid #555', margin: 5, borderRadius: 5 }}>
                <div style={{ backgroundColor: item.color, height: 30, width: 30, borderRadius: 5, marginRight: 10  }}></div>
                <div>{item.crewName}</div>
              </div>
            )
          })
        }
      </Grid>
    </Grid>
  )
}
const MarkerDetails = ({ markers, handleClearPolygons}) => {
  console.log('Markers in details...', markers.length)
  let totalMinutesOfWork = 0
  let totalDollars = 0
  markers.map(item => {
    totalMinutesOfWork += Number(item.estMinutes)
    totalDollars += Number(item.price)
  })
  totalDollars = parseFloat(totalDollars).toFixed(2)
  return (
    <div>
      <Button onClick={handleClearPolygons}>Clear</Button>
      Markers Selected: {markers.length}
      <br />
      Total Minutes of Work: {totalMinutesOfWork}
      <br/>
      Total $: {totalDollars}
      {
        markers.map((item, index) => {
          console.log(item)
          return (
            <div key={index} style={{ margin: 5, padding: 10, borderRadius: 10, backgroundColor: '#fff' }}>
              Client: {item.clientName}<br/>
              Price: {item.price}<br/>
              Minutes: {item.estMinutes}
            </div>
          )
        })
      }
    </div>
  )
}
// function stringToColorCode(inputString) {
//   // Take the first 6 characters of the input string
//   const substring = inputString.substring(0, 6);

//   // Convert the substring to a hexadecimal number
//   const colorCode = parseInt(substring, 16);

//   // Convert the number to a 6-digit hexadecimal string
//   const hexColor = colorCode.toString(16).padStart(6, '0');

//   // Add a '#' prefix to make it a valid color code
//   return `#${hexColor}`;
// }
const setMarkerColorBasedOnCrew = (crewId, crews) => {
  console.log('Get hex for crew', crewId)
  let hexColor = '#f43acb'
  let crewIndex = crews.findIndex(crew => (crew._id === crewId))
  if (crewIndex > -1) {
    console.log('INDEX: ', crewIndex)
    hexColor = distinctHexColors[crewIndex]
    // console.log()
  }
  console.log('Hex color:', hexColor)
  // const substring = crewId.substring(0, 9)
  // const colorCode = parseInt(substring, 16);
  // const hexColor = colorCode.toString(16).padStart(6, '0');
  return `${hexColor}`;
}

function HMIMapView(props) {
  const [markers, setMarkers] = React.useState([])
  const [crews, setCrews] = React.useState([])
  const [state, setState] = React.useState({
    pending: false
  })
  const [activeMarker, setActiveMarker] = React.useState({})
  const [filteredCrews, setFilteredCrews] = React.useState([])
  const [filteredDays, setFilteredDays] = React.useState([])
  const [weekChosen, setWeekChosen] = React.useState('All')
  const [frequencyChosen, setFrequencyChosen] = React.useState('All')
  const [selectedMarkers, setSelectedMarkers] = React.useState([])
  const [polygons, setPolygons] = useState([])
  const [invalidMarkers, setInvalidMarkers] = useState([])
  const [legendData, setLegendData] = useState([])

  const mapRef = useRef();
  const polygonRefs = useRef([]);
  const activePolygonIndex = useRef();
  const autocompleteRef = useRef();
  const drawingManagerRef = useRef();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const chosenWeek = searchParams.get('chosenWeek');
  const day = searchParams.get('day');




  React.useEffect(() => {
    let isMounted = true

    const fetchMarkers = async () => {
      const response = await axios.get(`${props.url}/api/hmi/fetchMarkers`)
      if (response.data && response.data.markers) {
        console.log('Marker Data: ', response.data)
        if (isMounted && response.data && response.data.markers && response.data.markers.length) {
          console.log('Set the markers')
          filterOurMarkers(response.data.markers, response.data.crews)
          setCrews(response.data.crews)
        }
      }
    }

    fetchMarkers()

    return () => {
      isMounted = false
    }
  }, [])

  const filterOurMarkers = (data, listOfCrews) => {
    // console.log('Markers to Filter:', data)
    let cleanMarkers = []
    let newLegendData = []
    let indexes = []
    data.map((stop, stopIndex) => {
        // console.log('Stop:', stop)
        let latitude = null
        let longitude = null
        if (stop.location && stop.location.coordinates && stop.location.coordinates.length) {
          longitude = stop.location.coordinates[0]
          latitude = stop.location.coordinates[1]
        } else if (stop.latitude && stop.longitude) {
          longitude = stop.longitude
          latitude = stop.latitude
        }
        if (latitude && longitude) {
          const markerPosition = {
            lat: Number(latitude),
            lng: Number(longitude),
            // heading: Number(activity.location.coords.heading)
          }
          let newMarker = {
            _id: Date.now()+stopIndex,
            // crewId: crew._id,
            // color: crew.color,
            // crewName: crew.crewName,
            position: markerPosition,
            ...stop
          }
          // console.log('New Marker:', newMarker)
         
          if (stop && stop.assignedCrew) {
            // console.log('Gotta deal with this one!!!')
            let crewId = stop.assignedCrew
            if (crewId && crewId._id) crewId = crewId._id
            let crewIndex = listOfCrews.findIndex(item => (crewId === item._id))
            if (crewIndex > -1) {
              console.log('Crew Index', crewIndex)
              if (!indexes.includes(crewIndex)) {
                indexes.push(crewIndex)
              }
              console.log('Indexes', indexes)
              let color = distinctHexColors[crewIndex]
              console.log('Color', color)
              newMarker.color = color
              let crewName = listOfCrews[crewIndex]['name']
              let index = newLegendData.findIndex(item => (item.crewName === crewName))
              if (index === -1) {
                newLegendData.push({
                  crewName,
                  color
                })
              }
            }
          }
          cleanMarkers.push(newMarker)
        }
      })
    // console.log('Markers to set:', cleanMarkers)
    setMarkers(cleanMarkers)
    console.log('Set Legend', newLegendData)

    setLegendData(newLegendData)
    // setFilteredCrews(data)
  }
  // const OurCrews = () => {
  // // console.log('Get our crew data...', crews)
  //   if (crews && crews.length) {
  //     let markersToUse = []
  //     crews.map(crew => {
  //     // console.log('Crew to work on: ,', crew)
  //       // Get the last 5 checkins for this guy
  //       let data = crew.data.splice(crew.data.length - 5, crew.data.length)
  //     // console.log('Data to use: ', data)
  //       markersToUse = markersToUse.concat(data)
  //     })
  //   // console.log('We have %d total markers!!', markersToUse)
  //     setMarkers(markersToUse)
  //     return markersToUse
  //   } else {
  //     return <span>Nothing to Show</span>
  //   }
  // }


  const updateActiveMarker = (d) => {
  console.log('UPdate Active Marker: ', d)
    setActiveMarker(d)
  }

  const OurMarkers = ({ markers }) => {
    // console.log('Generate our Markes', markers.length)
    let icon = dfl
    if (markers && markers.length) {
      // console.log('Active Marker', activeMarker)
      let ourMarkers = []
      markers.map((jobsite, index) => {
        let isValid = false
      // console.log('Marker jobsite: ', jobsite)
        // if (addy && addy.entity === '610a290f45ef7427f94b2e78') {
        //   icon = benhart
        // }
        let markerPosition = {}
        let latitude = null
        let longitude = null
        if (jobsite.location && jobsite.location.coordinates && jobsite.location.coordinates.length) {
          longitude = jobsite.location.coordinates[0]
          latitude = jobsite.location.coordinates[1]
        } else if (jobsite.latitude && jobsite.longitude) {
          longitude = jobsite.longitude
          latitude = jobsite.latitude
        }

        if (longitude && latitude) {
        // console.log('Got activity.coords:::', activity.location)
          markerPosition = {
            lat: Number(latitude),
            lng: Number(longitude),
            // heading: Number(activity.location.coords.heading)
          }
          isValid = true
          // activity.location = activity.location.coords
        } else {
        // console.log('No fucking lat/lng...227', jobsite)
        }
        // console.log(markerPosition)
          let color = '#214'
          if (jobsite.color) color = jobsite.color
          if (activeMarker._id === jobsite._id) {
            color = '#832'
            // console.log('Change that color!!', color)
          }
          // color = setMarkerColorBasedOnCrew(jobsite.crewId, crews)
          // console.log('COLOR by Crew: ', color)
          // console.log(activeMarker)
          if (isValid) {
            ourMarkers.push(
              <CustomMarker
                onLoad={onLoad}
                key={index}
                position={markerPosition}
                icon={icon}
                color={color}
                jobsite={jobsite}
                activeMarker={activeMarker}
                updateActiveMarker={updateActiveMarker}
              />
            )
          } else {
            // setInvalidMarkers(prevMarkers => [...prevMarkers, jobsite]);
          }
      })
      return ourMarkers
    } else {
      return null
      //  (
      //   // <CustomMarker
      //   //   onLoad={onLoad}
      //   //   position={position}
      //   //   icon={icon}
      //   // />
      // )
    }
  }

  const updateTheMarkersOnTheMap = (data) => {
    // console.log('Update the visible markers:', data)
    let crewsToInclude = crews.filter(crew => (data.includes(crew._id)))
    // console.log('Use theese markers:', crewsToInclude)
    // filterOurMarkers(crewsToInclude, filteredDays, weekChosen, frequencyChosen)
  }

  const updateMarkersByDay = (data) => {
    // console.log('Update Markers by day', data, weekChosen)
    if (data && data.length) {
      // filterOurMarkers(filteredCrews, data, weekChosen, frequencyChosen)
      // setFilteredDays(data)
    }
  }

  const updateMarkersByWeek = (data) => {
    console.log('Update By Week', data)
    // filterOurMarkers(filteredCrews, filteredDays, data, frequencyChosen)
    // setWeekChosen(data)
  }

  const updateMarkersByFrequency = (data) => {
    console.log('Update By Frequency', data)
    // filterOurMarkers(filteredCrews, filteredDays, weekChosen, data)
    // setFrequencyChosen(data)
  }

  function onOverlayComplete(event) {
    // console.log('Overlay complete:', event)
    let newMarkers = []
    console.log('Type:', event.type)
    if (event.type === "circle") {
      const circle = event.overlay;
      
      markers.forEach(marker => {
          const isInside = window.google.maps.geometry.spherical.computeDistanceBetween(
              marker.position, 
              circle.getCenter()
          ) <= circle.getRadius();
          
          if (isInside) {
              // Marker is inside the circle
              // console.log('This one is inside ', marker)
              newMarkers.push(marker)
          }
      });
  } else if (event.type === "polygon") {
    const polygon = event.overlay;

    markers.forEach(marker => {
        const isInside = window.google.maps.geometry.poly.containsLocation(
            marker.position,
            polygon
        );
        
        if (isInside) {
            // Marker is inside the polygon
            console.log('This one is inside the polygon', marker);
            newMarkers.push(marker)
        }
    });
  }
  console.log('FInished coming up w/ updated markers', newMarkers)
  setSelectedMarkers(newMarkers)
}

const onLoadPolygon = (polygon, index) => {
  polygonRefs.current[index] = polygon;
}

const onClickPolygon = (index) => {
  console.log('on polygon click')
  activePolygonIndex.current = index; 
}

const handlePolygonClick = (index) => {
  console.log('Click Polygon')
  const shouldDelete = window.confirm("Do you want to delete this polygon?");
    if (shouldDelete) {
      // Create a new array without the clicked polygon
      const newPolygons = polygons.filter((_, i) => i !== index);
      setPolygons(newPolygons);
    }
}


const onEditPolygon = (index) => {
  console.log("On Edit polygon")
  const polygonRef = polygonRefs.current[index];
  if (polygonRef) {
      const coordinates = polygonRef.getPath()
          .getArray()
          .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }));

      const allPolygons = [...polygons];
      allPolygons[index] = coordinates;
      setPolygons(allPolygons)
  }
}
const clearAllPolygons= () => {
  setPolygons([])
}

const assignACrewToAJobSite = async (crewToAssign, currentCrews) => {
  console.log('Assign this crew:', crewToAssign)
  let crewIndex = currentCrews.findIndex(item => (crewToAssign._id === item._id))
  console.log('Crew Index', crewIndex)
  console.log(currentCrews)
  console.log('this guy', activeMarker)
  activeMarker.assignedCrew = crewToAssign
  let existingMarkers = [...markers]
  let color = '#fff'
  existingMarkers.map((item, index) => {
    if (item._id === activeMarker._id) {
      console.log('This is the one!', item)
      console.log(index)
      item.assignedCrew = crewToAssign
      item.color = distinctHexColors[crewIndex]
      color = distinctHexColors[crewIndex]
    }
  })
  console.log('Now filter these bitches', existingMarkers)
  filterOurMarkers(existingMarkers, currentCrews)
  const data = {
    crewId: crewToAssign._id,
    jobSiteId: activeMarker._id,
    color: color
  }
  const response = await axios.post(`${props.url}/api/hmi/assignCrewToJobsite`, data)
  if (response && response.data) {
    console.log('Saved ', response.data)
  } else {
    console.log('Not saved...')
  }
  // filterOurMarkers(prevMarkers => [...prevMarkers, activeMarker]);
}
const handleUnassign = async (marker) => {
  console.log('Remove the crew from this marker:', marker)
  activeMarker.assignedCrew = null
  let existingMarkers = [...markers]
  let color = '#214'
  existingMarkers.map((item, index) => {
    if (item._id === activeMarker._id) {
      console.log('This is the one!', item)
      console.log(index)
      item.assignedCrew = null
      item.color = color
    }
  })
  console.log('Now filter these bitches', existingMarkers)
  filterOurMarkers(existingMarkers, crews)
  const data = {
    crewId: null,
    jobSiteId: activeMarker._id
  }
  const response = await axios.post(`${props.url}/api/hmi/assignCrewToJobsite`, data)
  if (response && response.data) {
    console.log('Saved ', response.data)
  } else {
    console.log('Not saved...')
  }
}
const irrigationTechs = props.crews.filter(crew => (crew.division && crew.division === 'Irrigation and Lighting'))

console.log('Polygons:', polygons)
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GMAPKEY}
      libraries={mapLibraries}
    >
    
      <Grid container>
      <Grid item lg={12} xs={12} md={12} sm={12}>
        Assigned Irrigation Crews
      </Grid>
        <Grid item lg={9} xs={9} md={9} sm={9}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={9}
          >
              <DrawingManager 
                  defaultDrawingMode={'POLYGON'}
                  onOverlayComplete={onOverlayComplete}
                  defaultOptions={{
                    drawingControl: true,
                    drawingControlOptions: {
                      position: 'TOP_CENTER',
                      drawingModes: [
                        'POLYGON'
                      ]
                    },
                    polygonOptions: {
                      fillColor: '#accacd',
                      fillOpacity: 1,
                      strokeWeight: 5,
                      clickable: true,
                      editable: true,
                      draggable: true,
                      zIndex: 1
                    }
                  }}
              
              />
               {/* {
                        polygons.map((iterator, index) => (
                            <Polygon
                                key={index}
                                onLoad={(event) => onLoadPolygon(event, index)}
                                onMouseDown={() => onClickPolygon(index)}
                                onMouseUp={() => onEditPolygon(index)}
                                onDragEnd={() => onEditPolygon(index)}
                                onClick={() => handlePolygonClick(index)}
                                options={polygonOptions}
                                paths={iterator}
                                draggable
                                editable
                            />
                        ))
                    } */}

            { /* Child components, such as markers, info windows, etc. */ }
            <>
            { (markers && markers.length) ? <OurMarkers markers={markers} /> : null }
            </>
          
          </GoogleMap>
        </Grid>
        <Grid item lg={3} xs={3} md={3} sm={3}>    
          <Sidebar
            url={props.url}
            markers={markers}
            invalidMarkers={invalidMarkers}
            selectedMarkers={selectedMarkers}
            clearPolygons={clearAllPolygons} 
            setActiveMarker={setActiveMarker} 
            activeMarker={activeMarker} 
            crews={irrigationTechs}
            handleAssignCrew={assignACrewToAJobSite}
            handleUpdateVisibleCrews={updateTheMarkersOnTheMap} 
            handleUpdateVisibleDays={updateMarkersByDay} 
            handleUpdateVisibleByWeek={updateMarkersByWeek} 
            handleUpdateVisibilityByFrequency={updateMarkersByFrequency}
            legendData={legendData}
            handleUnassign={handleUnassign}
           />
        </Grid>
      </Grid>

    </LoadScript>
  )
}
const days = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'None'
]

const weekOptions = [
  'All',
  'Odd',
  'Even'
]

const FilterArea = (props) => {
  const [assignedCrew, setAssignedCrew] = React.useState({})
  const somethingMeaningful = new Date()
  const updateAssignedCrew = (e, newCrew) => {
    console.log('Crew:', newCrew)
    if (newCrew && newCrew._id) props.assignThisCrew(newCrew, props.crews)
  }
  return (
    <div style={{ paddingVertical: 20 }}>
      <Autocomplete
        id="AssignedCrew"
        options={props.crews}
        getOptionLabel={(option) => option.name}
        // style={{ width: 200 }}
        key={somethingMeaningful}
        onChange={updateAssignedCrew}
        // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
        // value = {assignedCrew}
        // onChange={ e => setState({...state, employee: {...state.employee, employeeType: e.target.value}, requiresUpdate: true }) }
        renderInput={(params) => <TextField {...params} label="Assigned Crew" variant="outlined" />}
      />
    </div>
  )
}

const FrequencyChooser = (props) => {
  console.log('FrequencyChooser Chooser ', props)
  
    const handelChangeFrequency = (e) => {
      props.changeFrequency(e.target.value)
    }
  
    return (
      <Paper style={{ marginTop: 20, padding: 10, paddingBottom: 15 }} >
        <div style={{ fontSize: '18px', color: '#aaa' }}>Choose Which Type of Frequency Should Be Included:</div>
         <FormControl fullWidth>
          <TextField
            value={props.frequencyChosen}
            onChange={handelChangeFrequency}
            inputProps={{ 'aria-label': 'Day of the Week' }}
            fullWidth
            select
            style={{ margin: 5, padding: 10}}
            placeholder="Choose Which Day"
          >
             <MenuItem value={"All"}>
              All
            </MenuItem>
            <MenuItem value={"weekly"}>
              Weekly
            </MenuItem>
            <MenuItem value={"biweekly"}>Bi-Weekly</MenuItem>
          </TextField>
          <FormHelperText>Weekly/Bi-Weekly/All</FormHelperText>
        </FormControl>
      </Paper>
    )
  }

  const WeekChooser = (props) => {
    console.log('Week Chooser ', props)
    
      const handleChangeWeek = (e) => {
        props.changeWeek(e.target.value)
      }
    
      return (
        <Paper style={{ marginTop: 20, padding: 10, paddingBottom: 15 }} >
          <div style={{ fontSize: '18px', color: '#aaa' }}>Choose Which Weeks Should Be Included:</div>
           <FormControl fullWidth>
            <TextField
              value={props.weekChosen}
              onChange={handleChangeWeek}
              inputProps={{ 'aria-label': 'Day of the Week' }}
              fullWidth
              select
              style={{ margin: 5, padding: 10}}
              placeholder="Choose Which Day"
            >
               <MenuItem value={"All"}>
                All
              </MenuItem>
              <MenuItem value={"Odd"}>
                Odd (1, 3, 5, 7...)
              </MenuItem>
              <MenuItem value={"Even"}>Even (2, 4, 6, 8...)</MenuItem>
            </TextField>
            <FormHelperText>Odd Or Even Weeks of the Year</FormHelperText>
          </FormControl>
        </Paper>
      )
    }


const DayOptions = ({ selected, handleSelectAll, handleSelect }) => {

return (
  <Paper style={{ overflowY: 'scroll', marginTop: 20 }}>
     <div style={{ fontSize: '18px', color: '#aaa' }}>Choose Which Days Should Be Included:</div>
      <Table size="small">
          <TableHead>
              <TableRow>
                  <TableCell padding="checkbox">
                      <Checkbox
                          checked={selected.length === days.length}
                          onChange={handleSelectAll}
                      />
                  </TableCell>
                  <TableCell>Day (SELECT ALL)</TableCell>
              </TableRow>
          </TableHead>
          <TableBody>
              {days.map((day, index) => {
                const checked = selected.includes(day) ? true : false
             
                return (
                  <TableRow key={index}
                    
                  >
                      <TableCell padding="checkbox">
                          <Checkbox
                              checked={checked}
                              onChange={() => handleSelect(day)}
                          />
                      </TableCell>
                     
                      <TableCell >{day}</TableCell>
                  </TableRow>
              )})}
          </TableBody>
      </Table>
  </Paper>
)
}

const CrewOptions = ({ selected, crews, handleSelectAll, handleSelect }) => {
  return (
    <Paper style={{ overflowY: 'scroll', marginTop: 20 }}>
       <div style={{ fontSize: '18px', color: '#aaa' }}>Choose Which Crews Should Be Included:</div>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox
                            checked={selected.length === crews.length}
                            onChange={handleSelectAll}
                        />
                    </TableCell>
                    <TableCell>Crew Name (SELECT ALL)</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {crews.map((crew) => {
                  const checked = selected.includes(crew._id) ? true : false
                  let bgColor = checked ? crew.color : 'inherit'
                  let fontColor = checked ? '#fff' : 'inherit'
                  return (
                    <TableRow key={crew._id}
                      
                    >
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={checked}
                                onChange={() => handleSelect(crew._id)}
                            />
                        </TableCell>
                       
                        <TableCell style={{ backgroundColor: bgColor, color: fontColor }} >{crew.crewName}</TableCell>
                    </TableRow>
                )})}
            </TableBody>
        </Table>
    </Paper>
  )
}

// export default React.memo(MyComponent)
const mapStateToProps = (state) => {
  return {
    url: state.url,
    user: state.user,
    crews: state.crews,
    notification: state.notification
  }
}

export default connect(mapStateToProps)(React.memo(HMIMapView))
